import { Grid, Heading, Text } from "@chakra-ui/react";
import { RichText } from "./RichText";
import type { SectionHead as SectionHeadContent } from "@/content";

type SectionHeadProps = {
  head: SectionHeadContent;
  layout?: "start" | "center" | "split";
};

export const SectionHead = ({ head, layout = "start" }: SectionHeadProps) => {
  const isCenter = layout === "center";
  const isSplit = layout === "split";

  return (
    <Grid
      gap="18px"
      mb="head"
      justifyItems={isCenter ? "center" : undefined}
      textAlign={isCenter ? "center" : undefined}
      templateColumns={isSplit ? { base: "1fr", lg: "1.2fr 0.8fr" } : "1fr"}
      alignItems={isSplit ? "end" : undefined}
    >
      <Text variant="eyebrowBrand" gridColumn={isSplit ? "1 / -1" : undefined}>
        {head.eyebrow}
      </Text>
      <Heading as="h2" variant="section" maxW={isCenter ? "20ch" : undefined}>
        {head.title}
      </Heading>
      <Text variant="lede" maxW={isCenter ? "52ch" : undefined} justifySelf={isSplit ? { lg: "end" } : undefined}>
        <RichText nodes={head.lede} />
      </Text>
    </Grid>
  );
};
